import styled from "styled-components";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import PrimaryButton from "../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../components/FormControls/SecondaryButton";
import { useNavigate } from 'react-router-dom';
import CopyYear from "./CopyYear";
import BranchSummary from "./Reporting/BranchSummary";
import BankAccountBalances from "./Reporting/BankAccountBalances";
import OverDueYearEndFiling from "./Reporting/OverDueYearEndFiling";
import YearEndSignOff from "./Reporting/YearEndSignOff";

const StyledHomePage = styled.div`
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    background-color: ${(props) => props.theme.color.lightgray};
    padding: 45px;
    height: calc(100vh - 210px);
    overflow: auto;

`;

const PageContent = styled.div`
    width: 1000px;
    margin: auto;
`;

const HomePageTitle = styled.span`
    color: ${(props) => props.theme.color.dark};
    font-weight: 600;
    font-size: 20px;
`;

const DataBase = styled.span`
    font-size: 14px;
    color: ${(props) => props.theme.color.primaryblue};
    font-weight: 600;
`;

const DBName = styled.span`
    color: ${(props) => props.theme.color.gray};
    padding-left: 10px;
    font-weight: 600;
    font-size: 12px;
`;

const WhiteBoard = styled.div`
    background-color: white;
    padding: 30px;
    box-sizing: border-box;
`;

const WhiteBoardTitle = styled.span`
    color: ${(props) => props.theme.color.dark};
    font-weight: 600;
    font-size: 20px;
`;

function HomePage(props) {

    const navigate = useNavigate();

    const MODAL_NONE = 0;
    const MODAL_COPY_YEAR = 1;
    const MODAL_BRANCH_SUMMARY = 2;
    const MODAL_BANK_ACCOUNT_BALANCES = 3;
    const MODAL_OVERDUE_YEAR_ENDING_FILING = 4;
    const MODAL_YEAR_END_SIGN_OFF = 5;

    const [showingModal, setShowingModal] = useState(MODAL_NONE);

    return (
        <StyledHomePage>
            <PageContent>
                <HomePageTitle>CAMRA Online Admin</HomePageTitle>
                <div style={{paddingTop:15}}>
                    <DataBase>Database</DataBase>
                    <DBName>{props.databaseName}</DBName>
                </div>
                <div style={{paddingTop:15}}>
                    <SecondaryButton caption='Opening / brought forward balances' onClick={() => navigate('/openingbalances/balancesheet')} style={{width:380}}></SecondaryButton>
                </div>
                <div style={{paddingTop:30, display:'flex'}}>
                    <WhiteBoard style={{width:230, height:262}}>
                        <WhiteBoardTitle>System settings</WhiteBoardTitle>
                        <PrimaryButton caption='Branch / Sub-branch' onClick={() => navigate('/settings/branch')} style={{width:170, marginTop:30}}></PrimaryButton>
                        <PrimaryButton caption='Users & user rules' onClick={() => navigate('/settings/usersettings')} style={{width:170, marginTop:20}}></PrimaryButton>
                        <PrimaryButton caption='Settings' onClick={() => navigate('/settings/system')} style={{width:170, marginTop:20}}></PrimaryButton>
                    </WhiteBoard>
                    <WhiteBoard style={{width:230, height:262, marginLeft:26}}>
                        <WhiteBoardTitle>System structure</WhiteBoardTitle>
                        <PrimaryButton caption='Account types' onClick={() => navigate('/systemstructure/accounttypes')} style={{width:170, marginTop:30}}></PrimaryButton>
                        <PrimaryButton caption='Account sections' onClick={() => navigate('/systemstructure/accountsections')} style={{width:170, marginTop:20}}></PrimaryButton>
                        <PrimaryButton caption='Account section codes' onClick={() => navigate('/systemstructure/accountsectioncodes')} style={{width:170, marginTop:20}}></PrimaryButton>
                    </WhiteBoard>
                    <WhiteBoard style={{width:230, height:262, marginLeft:26}}>
                        <WhiteBoardTitle>Admin actions</WhiteBoardTitle>
                        <PrimaryButton caption='Messages' onClick={() => navigate('/admin/messages/main')} style={{width:170, marginTop:30}}></PrimaryButton>
                        <PrimaryButton caption='Audit Log' onClick={() => navigate('/admin/auditlog')} style={{width:170, marginTop:20}}></PrimaryButton>
                        <PrimaryButton caption='Copy Year' onClick={() => setShowingModal(MODAL_COPY_YEAR)} style={{width:170, marginTop:20}}></PrimaryButton>
                    </WhiteBoard>
                    <WhiteBoard style={{width:230, height:318, marginLeft:26}}>
                        <WhiteBoardTitle>Reporting</WhiteBoardTitle>
                        <PrimaryButton caption='Branch Summary' onClick={() => setShowingModal(MODAL_BRANCH_SUMMARY)} style={{width:170, marginTop:30}}></PrimaryButton>
                        <PrimaryButton caption='Bank Account Balances' onClick={() => setShowingModal(MODAL_BANK_ACCOUNT_BALANCES)} style={{width:170, marginTop:20}}></PrimaryButton>
                        <PrimaryButton caption='Overdue Year-End Filing' onClick={() => setShowingModal(MODAL_OVERDUE_YEAR_ENDING_FILING)} style={{width:170, marginTop:20}}></PrimaryButton>
                        <PrimaryButton caption='Year-End Sign off' onClick={() => setShowingModal(MODAL_YEAR_END_SIGN_OFF)} style={{width:170, marginTop:20}}></PrimaryButton>
                    </WhiteBoard>
                </div>
            </PageContent>
            <NotificationContainer/>

            {showingModal === MODAL_COPY_YEAR && <CopyYear
                handleClickNo = {() => setShowingModal(MODAL_NONE)}
            />}
            {showingModal === MODAL_BRANCH_SUMMARY && <BranchSummary
                handleClickNo = {() => setShowingModal(MODAL_NONE)}
            />}
            {showingModal === MODAL_BANK_ACCOUNT_BALANCES && <BankAccountBalances
                handleClickNo = {() => setShowingModal(MODAL_NONE)}
            />}
            {showingModal === MODAL_OVERDUE_YEAR_ENDING_FILING && <OverDueYearEndFiling
                handleClickNo = {() => setShowingModal(MODAL_NONE)}
            />}
            {showingModal === MODAL_YEAR_END_SIGN_OFF && <YearEndSignOff
                handleClickNo = {() => setShowingModal(MODAL_NONE)}
            />}
        </StyledHomePage>
    )
}

export default HomePage;